import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { SidebarStateKey } from 'applications/GSP/layouts/MainLayout/components/Sidebar/store';
import {
  openedMixin,
  closedMixin,
} from 'applications/GSP/layouts/MainLayout/components/Sidebar/utils';

import type { SidebarAnimatedComponentsState } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

const openedWrapperWidth = 221;
const closedWrapperWidth = 52;

export const SchoolLogoWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== SidebarStateKey.Opened,
})<SidebarAnimatedComponentsState>(({ theme, opened }) => ({
  justifySelf: 'center',
  marginTop: theme.spacing(1.5),
  overflow: 'hidden',
  display: 'grid',
  justifyContent: opened ? 'start' : 'center',
  width: opened ? openedWrapperWidth : closedWrapperWidth,
  ...(opened && {
    ...openedMixin({ theme }),
  }),
  ...(!opened && {
    ...closedMixin({ theme }),
  }),
}));
